import classNames from 'classnames'
import { useState } from 'react'
import { Tooltip } from 'app/components/Tooltip'
import { sanitizeName } from 'app/sanitize-name'

const EMPTY_KEYS: string[] = []

type Props = {
  map: Record<string, string | undefined | null | React.ReactNode>
  cols?: number
  className?: Record<string, string | undefined | null>
  omitLabels?: string[]
  actions?: Record<string, React.ReactNode>
}

export function KeyValueDrawer({ map, cols = 3, className, omitLabels = EMPTY_KEYS, actions }: Props) {
  const [activeTooltip, setActiveTooltip] = useState<{ key: string; content: React.ReactNode } | undefined>(undefined)
  return (
    <div className={`grid grid-cols-${cols} gap-3`}>
      {Object.entries<string | undefined | null | React.ReactNode>(map).map(([k, v]) => {
        return (
          v && (
            <div key={k} className="group flex flex-col gap-y-1">
              {!omitLabels.includes(k) && (
                <Tooltip
                  placement="top"
                  message={activeTooltip?.key === `label:${k}` ? activeTooltip.content : undefined}
                  className="truncate text-body-xs text-subtle"
                  keepOpen
                  onMouseOver={(event) => {
                    if (
                      event.currentTarget instanceof HTMLElement &&
                      event.currentTarget.scrollWidth > event.currentTarget.clientWidth
                    ) {
                      setActiveTooltip({
                        key: `label:${k}`,
                        content: <div className="max-w-sm break-words text-body-xs text-strong">{k}</div>,
                      })
                    } else {
                      setActiveTooltip(undefined)
                    }
                  }}
                >
                  {k}
                </Tooltip>
              )}
              {typeof v === `string` ? (
                <div className="flex items-center gap-x-1">
                  <Tooltip
                    placement="top"
                    message={activeTooltip?.key === k ? activeTooltip.content : undefined}
                    className={classNames(`mt-0.5 truncate break-words text-ui-xs text-strong`, className?.[k])}
                    keepOpen
                    onMouseOver={(event) => {
                      if (
                        event.currentTarget instanceof HTMLElement &&
                        event.currentTarget.scrollWidth > event.currentTarget.clientWidth
                      ) {
                        setActiveTooltip({
                          key: k,
                          content: (
                            <div className="flex max-w-sm flex-col gap-y-1">
                              <div className="text-body-xs text-subtle">{k}</div>
                              <div className="break-words text-ui-xs text-strong">{sanitizeName(v)}</div>
                            </div>
                          ),
                        })
                      } else {
                        setActiveTooltip(undefined)
                      }
                    }}
                  >
                    {sanitizeName(v)}
                  </Tooltip>
                  {actions?.[k]}
                </div>
              ) : (
                v
              )}
            </div>
          )
        )
      })}
    </div>
  )
}
